<template>
  <div>
    <div>
      <h1 style="text-align:center">
        EDITOR JS EXPERIEMENT
      </h1>
    </div>
    <v-btn @click="editorJS.readOnly.toggle()">READONLY</v-btn>
    <div class="editorx_body">
      <!--editorjs id-->
      <!-- <div class :id="editorId" ref="codeEditor" /> -->
      <div :id="editorId" ref="codeEditor" />
    </div>
    <button
      style="margin-left: 30%;"
      type="button"
      name="button"
      @click="save()"
    >
      save
    </button>
    <div class="editorx_body">
      <pre>{{ value }}</pre>
    </div>
  </div>
</template>

<script>
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import Paragraph from "@editorjs/paragraph";
import List from "@editorjs/list";
const RawTool = require("@editorjs/raw");

import draggable from "vuedraggable";

function uuid() {
  // uuidv4: Random UUID generator
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

export default {
  name: "ContentEditor",
  components: {
    draggable,
  },
  props: {
    editorId: {
      default: function() {
        let holderId = `codex-editor-${uuid()}`;
        return holderId;
      },
    },
  },
  data() {
    return {
      value: null,
      editorJS: null,
    };
  },
  methods: {
    save: function() {
      this.editorJS.save().then((savedData) => {
        console.log(savedData);
        this.value = savedData;
      });
    },
    init: function() {
      //let editorHolder = this.$refs.codeEditor; // using refs to identify editorJs holder
      //console.log("ref", editorHolder);
      this.editorJS = new EditorJS({
        holder: this.editorId, // using editorId as wrapper
        //holder: editorHolder,
        readOnly: false,
        autofocus: true,
        minHeight: 30,
        /**
         * This Tool will be used as default
         */
        defaultBlock: "paragraph",
        tools: {
          header: {
            class: Header,
            shortcut: "CMD+SHIFT+H",
            inlineToolbar: ["link", "marker", "bold", "italic"],
          },
          list: {
            class: List,
          },
          paragraph: {
            class: Paragraph,
            config: {
              placeholder: ".",
            },
          },
          raw: RawTool,
        },
        onReady: () => {
          console.log("ready");
          //   this.editorJS.blocks.renderFromHTML("<h1>Wolfgang</h1>");
        },
        onChange: () => {
          console.log("change");
          new DragDrop(this.editorJS);

          console.log("dragdrop", DragDrop);
        },
      });
      if (!window.arcEditor) {
        window.arcEditor = [];
        window.arcEditor.push(this.editorJS);
      } else {
        window.arcEditor.push(this.editorJS);
      }
    },
  },
  mounted: function() {
    this.init();
  },
};
</script>

<style lang="css" scoped>
.editorx_body {
  /* width: 62%;
  margin-left: 15%; */
  width: 60%;
  margin-left: 20%;
  border: 2px solid #f1f3f5;
  box-sizing: border-box;
}
</style>
<style lang="scss" scopped>
.ce-block.ce-block--focused {
  .ce-block__content {
    // background: lightgray;
    &::after {
      // content: "Add Content";
      position: absolute;
    }
  }
}

.ce-block--drop-target {
  .ce-block__content {
    opacity: 0.5;
    background: red;
  }
}
</style>
